import { useGlobal } from '@utmb/contexts/GlobalContext';
import { Font } from '@utmb/design-system/text/font';
import { Slice } from '@utmb/types/slice-handler';
import SliceStonesAllocationsView from '@utmb/types/view/SliceStonesAllocationsView';
import { parseMarkdown } from '@utmb/utils/markdown';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import styles from './stone-allocations.module.scss';
import StoneAllocationsTabs from './StoneAllocationsTabs';

const cx = classNames.bind(styles);

export const StoneAllocations = (props: Slice<SliceStonesAllocationsView>): ReactElement => {
    const { id, title, content, stonesAllocationsEvent, stonesAllocationsMajor, isDark } = props;

    const {
        global: {
            event: { primaryColorIsDark },
        },
    } = useGlobal();

    const saRootCSS = cx('container', styles.sa_root, {
        sa_root_dark: isDark,
    });

    return (
        <section id={id} className={saRootCSS}>
            <div className="row" style={{ alignItems: 'center' }}>
                <div className={`col-12 col-lg-6 ${styles.sa_col_content}`}>
                    {title && (
                        <Font.FuturaBold mobile="36" desktop="36" className={styles.sa_title}>
                            {title}
                        </Font.FuturaBold>
                    )}
                    {content && (
                        <Font.FuturaBook mobile="14" desktop="16" className={styles.sa_content} as="div">
                            <div
                                className={['markdown', primaryColorIsDark ? 'primaryColorIsDark' : null].filter(Boolean).join(' ')}
                                dangerouslySetInnerHTML={{ __html: parseMarkdown(content) }}
                            />
                        </Font.FuturaBook>
                    )}
                </div>
                {stonesAllocationsEvent && stonesAllocationsMajor && (
                    <div className={`col-12 col-lg-6 col-xl-5 ${styles.sa_col_spacer}`}>
                        <StoneAllocationsTabs {...props} />
                    </div>
                )}
            </div>
        </section>
    );
};
